import { useGetActiveTransactionsByTokenId } from 'src/features/common/profile/hooks/useGetActiveTransactionsByTokenId.hook';
import { ITransactionStatusE } from 'src/services/transactions/types';
import { useCollectible } from './collectible.hooks';

export const useGetActiveTokenTransaction = (status: ITransactionStatusE = ITransactionStatusE.Pending) => {
    const nft = useCollectible();
    return useGetActiveTransactionsByTokenId(nft!, status);
};
